import React from "react"
import { Box } from "@mui/material"

// Shared uppercase section label used across the Options-step tabs.
export const SECTION_LABEL_SX = {
  fontSize: "10.5px",
  fontWeight: 700,
  color: "#5b7f9c",
  textTransform: "uppercase",
  letterSpacing: "0.4px",
  mb: 0.75,
}

// Small colored square + label used in chart/table legends.
export function LegendSwatch({ color, label }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Box sx={{ width: 10, height: 10, borderRadius: "2px", bgcolor: color }} />
      {label}
    </Box>
  )
}
